import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import ProductGroupStatusChangeChartView from 'src/components/ProductGroupStatusChangeChart.js';
import UserTypeBasedSubStatusChart from 'src/components/UserTypeBasedSubStatusChart';
import ExchangeReceiptDayDistributionsChart from 'src/components/ExchangeReceiptDayDistributionsChart';
import TodayRefundTotalPriceChart from 'src/components/TodayRefundTotalPriceChart';
import ExchangeReceiptsBasedWarrantyTypesChart from 'src/components/ExchangeReceiptsBasedWarrantyTypesChart';
import OpenExchangeReceiptsWithDaysRangeChart from 'src/components/OpenExchangeReceiptsWithDaysRangeChart';
import LoginLogoutInformationChart from 'src/components/LoginLogoutInformationChart';
import AssignedJobPoolChart from 'src/components/AssignedJobPoolChart';
import AssembledReceiptOfExchangeReceiptsChart from 'src/components/AssembledReceiptOfExchangeReceiptsChart';

function SectionTitle({ children }) {
  return (
    <Typography
      sx={{ fontSize: '11px', fontWeight: 700, color: '#ef6c00', letterSpacing: '1px', textTransform: 'uppercase', mb: 1.25, mt: 0.5 }}
    >
      {children}
    </Typography>
  );
}

/*
  Yukarıdan aşağıya: ara durum heatmap'i → anlık özet rakamlar → açık fiş dağılımları.
*/
function GeneralMonitoring() {
  return (
    <Box
      sx={{
        fontFamily: 'Segoe UI',
        p: { xs: 1.5, sm: '16px 24px' }
      }}
    >
      <SectionTitle>Ara Durum Dağılımı</SectionTitle>
      <UserTypeBasedSubStatusChart />

      <Box sx={{ mt: 3 }}>
        <SectionTitle>Anlık Durum</SectionTitle>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={6}>
            <LoginLogoutInformationChart />
          </Grid>
          <Grid item xs={12} lg={6}>
            <AssignedJobPoolChart />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TodayRefundTotalPriceChart />
          </Grid>
          <Grid item xs={12} lg={6}>
            <AssembledReceiptOfExchangeReceiptsChart />
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ mt: 3 }}>
        <SectionTitle>Açık Değişim Fişleri</SectionTitle>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={6}>
            <ExchangeReceiptDayDistributionsChart />
          </Grid>
          <Grid item xs={12} lg={6}>
            <OpenExchangeReceiptsWithDaysRangeChart />
          </Grid>
          <Grid item xs={12} lg={6}>
            <ExchangeReceiptsBasedWarrantyTypesChart />
          </Grid>
          <Grid item xs={12} lg={6}>
            <ProductGroupStatusChangeChartView />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default GeneralMonitoring;
